import { Bug, AlertTriangle, Mail, Tag } from 'lucide-react';
import { defineSchema } from '@shared/search';

export const bugsSchema = defineSchema({
  id: 'bugs',
  title: 'filter.bugs.title',
  subtitle: 'filter.bugs.subtitle',
  defaultField: 'title',
  fields: {
    title: {
      key: 'title',
      label: 'filter.field.bugTitle',
      type: 'text',
      icon: Bug,
      placeholder: 'filter.placeholder.bugTitle',
      description: 'filter.desc.bugTitle',
      example: 'crash',
    },
    status: {
      key: 'status',
      label: 'bugs.status',
      type: 'enum',
      icon: Tag,
      allowMultiple: true,
      description: 'filter.desc.bugStatus',
      options: [
        { value: 'open', label: 'bugs.statusOpen' },
        { value: 'in_progress', label: 'bugs.statusInProgress' },
        { value: 'closed', label: 'bugs.statusClosed' },
      ],
      example: 'status:open',
    },
    severity: {
      key: 'severity',
      label: 'bugs.severity',
      type: 'enum',
      icon: AlertTriangle,
      allowMultiple: true,
      description: 'filter.desc.bugSeverity',
      options: [
        { value: 'critical', label: 'bugs.severityCritical' },
        { value: 'high', label: 'bugs.severityHigh' },
        { value: 'medium', label: 'bugs.severityMedium' },
        { value: 'low', label: 'bugs.severityLow' },
      ],
      example: 'severity:high',
    },
    email: {
      key: 'email',
      label: 'bugs.submitter',
      type: 'text',
      icon: Mail,
      placeholder: 'filter.placeholder.bugEmail',
      description: 'filter.desc.bugEmail',
      example: 'email:gmail.com',
    },
    env: {
      key: 'env',
      label: 'filter.field.bugEnv',
      type: 'enum',
      icon: Tag,
      allowMultiple: true,
      description: 'filter.desc.bugEnv',
      options: [
        { value: 'prod', label: 'prod' },
        { value: 'dev', label: 'dev' },
        { value: 'local', label: 'local' },
      ],
      example: 'env:prod',
    },
  },
  examples: [
    { q: 'status:open', desc: 'filter.bugs.example1' },
    { q: 'status:open env:prod', desc: 'filter.bugs.example2' },
    { q: 'crash status:open', desc: 'filter.bugs.example3' },
  ],
});
